import { forwardRef } from "react";
import { ModalContent, ModalOverlay } from "@chakra-ui/react";
import { glassContentSx } from "@/theme/glassSx";

/**
 * Drop-in replacement for Chakra's ModalContent that turns any legacy dialog
 * into a white translucent liquid-glass sheet with dark ink typography.
 */
export const GlassModalContent = forwardRef(function GlassModalContent(
  { children, sx, ...props },
  ref
) {
  return (
    <ModalContent
      ref={ref}
      bg="glass.solid"
      color="text.onGlass"
      backdropFilter="blur(24px) saturate(150%)"
      border="1px solid"
      borderColor="whiteAlpha.800"
      borderRadius="modal"
      boxShadow="overlay"
      mx={{ base: 3, md: 4 }}
      sx={{
        ...glassContentSx,
        "@supports not ((-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px)))":
          { background: "rgba(255, 255, 255, 0.96)" },
        ...sx,
      }}
      {...props}
    >
      {children}
    </ModalContent>
  );
});

export function GlassModalOverlay(props) {
  return <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(8px)" {...props} />;
}

export default GlassModalContent;
